const getMapOptions = (lat, lng, zoom) => ({
  center: { lat, lng },
  mapTypeId: "satellite",
  zoom: 18,
});

export default getMapOptions;
